export default function getAllAttachmentIds(composeViewState) {
    var attachmentIds = [];
    var attachmentWell = composeViewState.attachmentWell;
    if (attachmentWell) {
        attachmentWell.docViewAttachments.forEach(function (attachment) {
            attachmentIds.push(attachment.attachmentId);
        });
        attachmentWell.inlineAttachments.forEach(function (attachment) {
            attachmentIds.push(attachment.attachmentId);
        });
        attachmentWell.imageViewAttachments.forEach(function (attachment) {
            attachmentIds.push(attachment.attachmentId);
        });
    }
    return attachmentIds;
}
//# sourceMappingURL=getAllAttachmentIds.js.map